<template>
  <div id="create">
    <toolBar @saveDesign="handleSaveDesign"></toolBar>
    <iframe
      ref="designer"
      frameborder="0"
      style="width: 100%; min-height: 100vh"
      :src="src"
      @load="init"
    />
    <div v-show="false" class="upload-btn-box">
      <Button @click="uploadImg" />
      <input ref="upload" type="file" @change="handleUpload" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import request from "@/utils/request"
import toolBar from "./toolBar.vue"

import { Base64 } from "js-base64"
import { uploadFile } from "./upload"
import { addImgMap } from "@/api/customProduct/imageStore"
import { addUserDesign } from "@/api/customProduct/design"
import { getProductDetail } from "@/api/customProduct/product"

export default {
  name: "create",
  inject: ["reload"],
  data() {
    return {
      src: `${window.location.origin}/web/`,
      _obj: {},
      form: {
        pId: "",
        printsParams: "",
        skuList: [],
        mapIds: [],
      },
      language: "zh",
      code: "HK",
      product: {},
      isSubmit: false,
    }
  },
  computed: {
    //
    //
    //
    //
    three_designer() {
      const iframe = this.$refs.designer.contentWindow
      return iframe.threedesigner
    },
    ...mapGetters(["user", "token"]),
    routeName() {
      return this.$route.path + "?pId=" + this.$route.query.pId
    },
  },
  mounted() {
    window.addEventListener("message", this.receiveDesignerAction)
  },
  watch: {
    routeName() {
      this.init()
    },
  },
  beforeDestroy(){
    document.getElementsByTagName('body')[0].style['overflow'] = 'inherit'
  },
  methods: {
    async init() {
      let pId = this.$route.query.pId
      if (pId) {
        let response = await getProductDetail(pId)
        this.code = response.data.proCode
        this.product = response.data
      }
      // 基本配置参数
      let host = location.host;

      let protocol = location.protocol

      document.getElementsByTagName('body')[0].style['overflow'] = 'hidden'
      const base_config = {
        token: this.token, // token
        domain: `${protocol}//${host}/prod-api`, // API接口地址 (例如: 'https://i3d.onewinner.cn/api/v1')
        public_images: "server/map/listComm3rd", // 公共图片列表接口
        images: "server/map/listMy3rd", // 个人图片列表接口
        basics: "server/product/list3rd", // 定制列表接口
        basic_categories: "server/cp/type/list3rd", // 定制分类接口
        lang: "zh", // 当前语言
        crossUrl: `${window.location.origin}/origin`, // 跨域请求被授权
      }

      let result = await request({
        url: "https://3ddesigner.softfulfillment.cn/api/design",
        method: "get",
        params: { code: this.code, api_key: "UFbQR6V74iob8WFx" },
      })
      let design_config = result.data

      result = await request({
        url: "https://3ddesigner.softfulfillment.cn/api/fonts",
        method: "get",
        params: { api_key: "UFbQR6V74iob8WFx" },
      })
      let font_list = result.data

      /**
       * 调用定制器内部初始化方法
       * @param {object} base_config 基本配置参数
       * @param {object} design_config 3d模型配置参数接口
       * @param {array} font_list 字体列表
       */
      if (this.three_designer) {
        window.setTimeout(() => {
          this.three_designer.initDesigner(
            base_config,
            design_config,
            font_list
          )
          // this.three_designer.changeLanguage(this.language)
          this._obj = this.three_designer
          document.getElementsByTagName('iframe')[0].focus()
        })
      }
    },
    /**
     * 添加图片
     */
    addImageEvent() {
      Laya.Browser.window.top.postMessage(
        {
          source: "threedesigner",
          funName: "addImageEvent",
        },
        this.config.crossUrl
      )
    },
    getFileInfo(file) {
      return new Promise((resolve, reject) => {
        var reader = new FileReader()
        reader.onload = function(event) {
          var txt = event.target.result
          var img = document.createElement("img")
          img.src = txt
          img.onload = function() {
            let record = {}
            record.picWidth = img.width
            record.picHeight = img.height
            resolve(record)
          }
        }
        reader.readAsDataURL(file)
      })
    },
    receiveDesignerAction({ data }) {
      if (data.source !== "threedesigner") return
      const { funName } = data
      // 监听添加图片事件
      if (funName === "addImageEvent") {
        this.uploadImg(data.params)
      }
      // 监听产品切换事件
      if (funName === "productChangedEvent") {
        this.changeBasic(data.params)
      }
      // 清空当前刀板元素
      if (funName === "clearModelPartEvent") {
      }
      // 清空当前刀板元素
      if (funName === "clearModelPartEvent") {
      }
    },
    changeBasic(basic) {
      this.$router.push({
        path: "",
        query: {
          pId: basic.id,
        },
      })
      // this.reload()
    },
    /**
     * 初始化定制器
     * @param {*} config 基本配置参数
     * @param {*} data 模型配置参数
     */
    initDesigner(config, data) {
      this.config = config
      this.data = data
      if (this._obj && this.data) {
        this._obj.loadData(this.data)
      }
    },
    /**
     * 添加图片
     * @param {*} info
     */
    addImage(info) {
      if (this._obj) {
        this._obj.addImage(info)
      }
    },
    /**
     * 处理上传图片
     * @param {object} event e
     */
    async handleUpload(event) {
      let _self = this
      let imageDataArr = []

      const file = event.target.files[0]
      const { uploadFlag, fileUrl } = await uploadFile(file)
      if (!uploadFlag) {
        _self.msgError("上传失败！")
        return
      }
      let fileInfo = await this.getFileInfo(file)
      let imageData = {}
      imageData.picUrl = fileUrl
      imageData.picWidth = fileInfo.picWidth
      imageData.picHeight = fileInfo.picHeight
      imageData.picName = file.name
      imageData.fileSize = file.size

      //上传低清图片
      if (imageData.picWidth > 150) {
        const img = await this.readImg(file)
        const blob = await this.compressImg(
          img,
          file.type,
          150,
          (150 * imageData.picHeight) / imageData.picWidth
        )
        var result = await uploadFile(blob)
        imageData.picUrl2 = result.fileUrl
      } else {
        imageData.picUrl2 = imageData.picUrl
      }

      if (imageData.picWidth > 500) {
        const img = await this.readImg(file)
        const blob = await this.compressImg(
          img,
          file.type,
          500,
          (500 * imageData.picHeight) / imageData.picWidth
        )
        var result = await uploadFile(blob)
        imageData.picUrl3 = result.fileUrl
      } else {
        imageData.picUrl3 = imageData.picUrl
      }

      imageDataArr.push(imageData)
      await addImgMap(imageDataArr)
        .then((response) => {
          if (response.code === 200) {
            _self.addImage({
              id: response.data[0].mapId,
              info: {
                width: fileInfo.picWidth,
                height: fileInfo.picHeight,
                type: file.type,
                size: file.size,
              },
              name: file.name,
              thumb: fileUrl,
              url: fileUrl,
            })
            _self._obj.refreshPrivateImages()
            _self.$message({
              message: "上传成功",
              type: "success",
              duration: 700,
            })
          } else {
            _self.msgError("上传失败！")
          }
        })
        .catch((err) => {
          console.error(err)
        })
      // 使用图库原本的图片
      this.addImage(this.file)
    },
    readImg(file) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        const reader = new FileReader()
        reader.onload = function(e) {
          img.src = e.target.result
        }
        reader.onerror = function(e) {
          reject(e)
        }
        reader.readAsDataURL(file)
        img.onload = function() {
          resolve(img)
        }
        img.onerror = function(e) {
          reject(e)
        }
      })
    },
    compressImg(img, type, mx, mh) {
      return new Promise((resolve, reject) => {
        const canvas = document.createElement("canvas")
        const context = canvas.getContext("2d")
        const { width: originWidth, height: originHeight } = img
        // 最大尺寸限制
        const maxWidth = mx
        const maxHeight = mh
        // 目标尺寸
        let targetWidth = originWidth
        let targetHeight = originHeight
        if (originWidth > maxWidth || originHeight > maxHeight) {
          if (originWidth / originHeight > 1) {
            // 宽图片
            targetWidth = maxWidth
            targetHeight = Math.round(maxWidth * (originHeight / originWidth))
          } else {
            // 高图片
            targetHeight = maxHeight
            targetWidth = Math.round(maxHeight * (originWidth / originHeight))
          }
        }
        canvas.width = targetWidth
        canvas.height = targetHeight
        context.clearRect(0, 0, targetWidth, targetHeight)
        // 图片绘制
        context.drawImage(img, 0, 0, targetWidth, targetHeight)
        canvas.toBlob(function(blob) {
          resolve(blob)
        }, type || "image/png")
      })
    },
    /**
     * 获取产品信息（包含配置参数和打印参数）
     */
    getProductInfo() {
      if (this._obj) {
        return this._obj.getProductInfo()
      }
    },
    /**
     * 获取打印参数信息
     */
    getDesignInfo() {
      if (this._obj) {
        return this._obj.getDesignInfo()
      }
    },
    /**
     * 清空全部画布
     */
    clearDesignInfo() {
      if (this._obj) {
        this._obj.clearDesignInfo()
      }
    },
    /**
     * 加载动画开始
     */
    startLoading() {
      if (this._obj) {
        this._obj.startLoading()
      }
    },
    /**
     * 加载动画结束
     */
    endLoading() {
      if (this._obj) {
        this._obj.endLoading()
      }
    },
    /**
     * 更新私人图库
     */
    refreshPrivateImages() {
      if (this._obj) {
        this._obj.refreshPrivateImages()
      }
    },
    /**
     * 切换语言
     * @param {string} language 当前语言
     */
    toggleLauguage(language) {},
    async handleSaveDesign(pId) {
      var loading = ``
      try {
        if (!pId) {
          this.msgWarning("请选择产品")
          return
        }
        if (this.isSubmit) {
          return
        }
        this.isSubmit = true

        loading = this.$loading({
          lock: true,
          text: "正在保存",
          background: "rgba(0, 0, 0, 0.7)",
          style: "width: 100%",
        })

        let productInfo = this.three_designer.getProductInfo()
        let mapIds = []
        let { designInfo, effectInfo, knivesInfo } = productInfo.egInfo

        for (let record of designInfo.parts) {
          for (let item of record.data.items) {
            mapIds.push(item.imgId)
          }
        }

        const canvas_json = {
          parts: designInfo.parts,
          psd_params: knivesInfo.partTexs.map((item) => {
            return {
              route: item.route,
              psd_params: item.psdParams,
            }
          }),
        }
        let printsParams = Base64.encode(JSON.stringify(canvas_json))
        let skuList = []
        for (let record of designInfo.effects) {
          var blob = this.dataURLtoBlob(record.base64)
          var file = this.blobToFile(blob, new Date().getTime() + ".png")
          let result = await uploadFile(file)
          skuList.push({
            color: record.colorName,
            imageUrl: result.fileUrl,
          })
        }
        this.form.mapIds = mapIds
        this.form.pId = pId
        this.form.printsParams = printsParams
        this.form.designId = ""
        this.form.canvasJson = "99"

        let colorList = []
        const newSkuList = []

        skuList.map((el) => {
          colorList.push(el.color)
        })

        colorList = this._.uniq(colorList)

        colorList.map((e) => {
          let ob = {
            color: e,
            imageList: [],
          }

          skuList.map((el) => {
            if (e === el.color) {
              ob.imageList.push(el.imageUrl)
            }
          })
          newSkuList.push(ob)
        })

        this.form.skuList = newSkuList

        await addUserDesign(this.form)
        this.$message({ message: "保存成功", type: "success", duration: 1000 })
        loading.close()
        this.isSubmit = false
      } catch (error) {
        loading.close()
        this.isSubmit = false

        console.log(error)
        console.log(error)
      }
    },
    uploadImg() {
      if (!this.$refs.upload) return
      this.$refs.upload.dispatchEvent(new MouseEvent("click"))
    },
    dataURLtoBlob: function(dataurl) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    //将blob转换为file
    blobToFile: function(theBlob, fileName) {
      theBlob.lastModifiedDate = new Date()
      theBlob.name = fileName
      return theBlob
    },
  },
  components: { toolBar },
}
</script>

<style scoped lang="scss"></style>
